// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, uiActions} from '@/store'

type Props = {
  addNewExport: () => void,
  l: Language,
  setupNewExportForm: () => void,
  showEditModal: (props: ModalProps) => void,
}

const RawNewExportButton = (props: Props) =>
  <button id="new_export"
    className="btn btn-success"
    onClick={() => {
      props.setupNewExportForm()
      props.showEditModal({
        title: 'New export',
        onConfirm: props.addNewExport,
      })
    }}
  >
    {props.l('New export')}
  </button>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawNewExportButton)



// WEBPACK FOOTER //
// ./src/views/exports-page/new-export-button.js